import React, { forwardRef } from 'react';
import TextareaAutosizeLib, {
  type TextareaAutosizeProps as LibTextareaAutosizeProps,
} from 'react-textarea-autosize';
import css from './TextareaAutosize.module.css';

interface TextareaAutosizeProps extends Omit<LibTextareaAutosizeProps, 'ref'> {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  className?: string;
  minRows?: number;
  maxRows?: number;
  disabled?: boolean;
  autoFocus?: boolean;
  name?: string;
  id?: string;
  maxLength?: number;
}

export const TextareaAutosize = forwardRef<
  HTMLTextAreaElement,
  TextareaAutosizeProps
>(
  (
    {
      value,
      onChange,
      onKeyDown,
      placeholder,
      className,
      minRows = 1,
      maxRows,
      disabled = false,
      autoFocus = false,
      name,
      id,
      maxLength,
      style,
      ...rest
    },
    ref,
  ) => {
    return (
      <TextareaAutosizeLib
        ref={ref}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        className={`${css.textarea} ${className || ''}`}
        minRows={minRows}
        maxRows={maxRows}
        disabled={disabled}
        autoFocus={autoFocus}
        name={name}
        id={id}
        maxLength={maxLength}
        style={style}
        cacheMeasurements
        {...rest}
      />
    );
  },
);

TextareaAutosize.displayName = 'TextareaAutosize';
